// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-12e1b452] tbody .el-table__cell {\n  padding: 0;\n}\n[data-v-12e1b452] tbody .dayTimeCss {\n  font-weight: bold;\n}\n[data-v-12e1b452] tbody .dayTimeCss:hover {\n    text-decoration: underline;\n    cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
